<template>
	<transition name="slide-banner" v-if="!scrollDown">
		<div class="banner banner-home" 
		:class="{'mobile': !$mq.isDesktop()}"
		:style="$route.meta.config ? $route.meta.config.top_banner_color : ''"
		 v-if="pageIsHome || pageIsPlans ||orderNow" >
			<span v-if="orderNow">
				CONSEGNA GRATUITA IN TUTTA ITALIA
			</span>
			<span v-else>
				<i class="fa fa-truck mr-3"></i>CONSEGNA IN TUTTA ITALIA, <br class="under" style="display: none">GRATUITA PER IL PRIMO ORDINE! <!-- PAGA ANCHE CON I TICKET RESTAURANT®.  -->
			</span>
		</div>
		<!-- <div class="banner banner-shop" :class="{'mobile': !$mq.isDesktop()}" v-if="pageIsShop">
			<span>
				<b>Per ordinare la tua spesa accedi o registrati</b>
			</span>
		</div> -->
	</transition>
</template>

<script>
export default {
	props: {
		orderNow: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			scrollDown: false
		}
	},
	mounted () {
		var currentPosition = 0
		this.$nextTick(function () {
			window.addEventListener('scroll', () => {
				//var scrollDown = () => window.scrollY > currentPosition && window.scrollY > 100
				//this.scrollDown = !!scrollDown()
				//currentPosition = window.scrollY
				this.scrollDown = window.scrollY > 0
			})
		})
	},

	computed: {
		pageIsShop () {
			if (['shop'].indexOf(this.$route.name) >= 0) return true
		},
		pageIsHome () {
			if (['home'].indexOf(this.$route.name) >= 0) return true
		},
		pageIsGiftCard () {
			if (['gift-card'].indexOf(this.$route.name) >= 0) return true
		},
		pageIsPlans () {
			if (['plans'].indexOf(this.$route.name) >= 0) return true
		}
	}
}
</script>

<style scoped>
.banner {
	width: 100%;
	z-index: 3;
	padding: 4px 0;
	font-size: 15px;
	text-align: center;
	/*transition: all 0.8s ease;*/
}

.banner-gift {
	font-weight: bold;
	color: white;
	background-color: black;
}

.banner-home {
	font-weight: bold;
	text-transform: uppercase;
	color: white;
	background-color: var(--quomi-primary);
}

.banner-shop {
	color: #856404;
    background-color: #FFF3CD;
    /*border-bottom: 1px solid;
    border-color: #FFEEBA !important;*/
}

.banner.mobile {
	position: relative !important;
}

.banner img {
	width: 17px;
}

.slide-banner-enter-active {
	/*transition: all 0.8s ease;*/
}

.slide-banner-leave-active {
	/*transition: all .5s ease;*/
}

.slide-banner-enter,
.slide-banner-leave-to {
	display: none;
}

@media (max-width: 1024px) {
	.banner {
		font-size: 15px;
	}
}

@media (min-width: 375px) and (max-width: 426px) {
	.under {
		display: block !important;
	}
}
</style>
